import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import userById from '../../common/helpers/userById';
import formatTimeLeft from '../../common/helpers/formatTimeLeft';
export default class ArenaBattleWaitPost extends Component {
  timerId = null;

  /** Battle event posts that can only appear AFTER this wait prompt. */
  static LATER_BATTLE_POST_TYPES = ['arenaBattleTurn', 'arenaBattleWait', 'arenaBattleNext', 'arenaBattleSurrender', 'arenaBattleExpired', 'arenaBattleDraw'];

  /**
   * Same reasoning as ArenaBattleNextTurnPost.isSuperseded(): once the
   * battle has visibly moved past this prompt, this post's expiresAt
   * snapshot is stale and its countdown must stop ticking.
   */
  isSuperseded() {
    const post = this.attrs.post;
    const discussion = post.discussion?.();
    if (!discussion) return false;
    const myNumber = post.number() ?? 0;
    return (discussion.posts?.() ?? []).some(p => p && p.id() !== post.id() && (p.number?.() ?? 0) > myNumber && ArenaBattleWaitPost.LATER_BATTLE_POST_TYPES.includes(p.contentType?.() ?? ''));
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.timerId = setInterval(() => m.redraw(), 60_000);
  }
  onremove(vnode) {
    if (this.timerId) clearInterval(this.timerId);
    super.onremove(vnode);
  }
  view() {
    const data = this.attrs.post.content();
    if (!data) return null;
    const {
      turn,
      playerName,
      waitingForName,
      playerId,
      waitingForId,
      expiresAt
    } = data;
    const timeLeft = this.isSuperseded() ? null : formatTimeLeft(expiresAt ?? null);

    // Server-resolved (see arenaCardBackDetails, visible to every viewer) —
    // not a client-side ARENA_CARD_BACKS lookup, which no longer carries
    // private ("Личная") backs at all (see FilterActiveCardBacks).
    const playedBack = userById(playerId)?.attribute('arenaCardBackDetails')?.imageUrl ?? null;
    const facedownBack = userById(waitingForId)?.attribute('arenaCardBackDetails')?.imageUrl ?? null;
    return m("div", {
      className: "ArenaTurnPost ArenaWaitPost EventPost"
    }, m("div", {
      className: "ArenaTurnPost-heading"
    }, m("i", {
      className: "fas fa-dungeon"
    }), m("span", null, app.translator.trans('forumaker-arena.forum.battle.turn_heading', {
      turn: String(turn)
    }))), m("div", {
      className: "ArenaTurnPost-cards"
    }, m("div", {
      className: "ArenaWaitPost-col"
    }, m("div", {
      className: "ArenaTurnPost-cardLabel"
    }, playerName), m("div", {
      className: "ArenaTurnPost-card ArenaWaitPost-played"
    }, m("div", {
      className: "ArenaTurnPost-cardInner ArenaWaitPost-cardInner"
    }, m("div", {
      className: `ArenaTurnPost-cardHeader ArenaWaitPost-cardBack ArenaWaitPost-cardBack--played${playedBack ? ' ArenaWaitPost-cardBack--skinned' : ''}`,
      style: playedBack ? {
        '--arena-card-back-image': `url(${playedBack})`
      } : undefined
    }, !playedBack && m("i", {
      className: "fas fa-check"
    })), m("div", {
      className: "ArenaTurnPost-cardBody"
    }, m("div", {
      className: "ArenaTurnPost-cardName",
      style: {
        justifyContent: 'center',
        fontSize: '.85em',
        color: 'var(--muted-color)'
      }
    }, app.translator.trans('forumaker-arena.forum.battle_wait.played')))))), m("div", {
      className: "ArenaTurnPost-vs"
    }, "VS"), m("div", {
      className: "ArenaWaitPost-col"
    }, m("div", {
      className: "ArenaTurnPost-cardLabel"
    }, waitingForName), m("div", {
      className: "ArenaTurnPost-card ArenaWaitPost-facedown"
    }, m("div", {
      className: "ArenaTurnPost-cardInner ArenaWaitPost-cardInner"
    }, m("div", {
      className: `ArenaTurnPost-cardHeader ArenaWaitPost-cardBack${facedownBack ? ' ArenaWaitPost-cardBack--skinned' : ''}`,
      style: facedownBack ? {
        '--arena-card-back-image': `url(${facedownBack})`
      } : undefined
    }, !facedownBack && m("i", {
      className: "fas fa-question"
    })))))), m("div", {
      className: "ArenaWaitPost-status"
    }, m("i", {
      className: "fas fa-hourglass-half"
    }), app.translator.trans('forumaker-arena.forum.battle_wait.waiting', {
      name: m("strong", null, waitingForName)
    }), timeLeft && m("span", {
      className: "ArenaWaitPost-timer",
      title: app.translator.trans('forumaker-arena.forum.card_slider.timer_title')
    }, m("i", {
      className: "fas fa-clock"
    }), " ", timeLeft)));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleWaitPost', ArenaBattleWaitPost);